// @flow
import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {get} from 'lodash';
import withLingua from '../withLingua/withLingua';
import {RecommendedDestinationsCarousel} from '@homeaway/react-property-carousel';
import routerActions from '../../actions/router';
import {
    BREAKPOINTS,
    LINGUA_TITLE_KEY,
    SERP_LARGE_SEARCH_TERM_DESTINATION,
    RECOMMENDED_DESTINATIONS_MIN_LIMIT
} from './constants';
import './DestinationCarousel.less';
import type {LinguaProps} from '../withLingua/withLingua';
import type {IntlShape} from 'react-intl';
import type {TypeaheadSuggestion} from '../../queries/searchRequestQuery';

type OwnProps = {
    isLoading: boolean,
    carouselData: any,
    intl: IntlShape,
    locationSearch: typeof routerActions.search,
    typeaheadSuggestion: TypeaheadSuggestion
};

type Props = OwnProps & LinguaProps;

export class DestinationCarousel extends PureComponent<Props> {
    handleOnClick = (
        evt: SyntheticEvent<HTMLInputElement>,
        position: number
    ) => {
        const {carouselData, locationSearch} = this.props;
        const index = position - 1;
        const placeNameFull = get(
            carouselData,
            `recommendedDestinations[${index}].breadcrumbs[0].place.name.full`,
            ''
        );

        if (placeNameFull) {
            locationSearch({q: placeNameFull});
        }
    };
    render() {
        const {
            isLoading,
            messages,
            typeaheadSuggestion: {name},
            intl,
            carouselData
        } = this.props;

        const title = messages[LINGUA_TITLE_KEY.carousel_title];

        const popularPlaceTitle = intl.formatMessage(
            {
                id: 'popularPlaceTitle',
                defaultMessage: title
            },
            {
                placeName: name
            }
        );
        return (
            <RecommendedDestinationsCarousel
                breakpoints={BREAKPOINTS}
                customCardClickHandler={this.handleOnClick}
                minDestinationCount={RECOMMENDED_DESTINATIONS_MIN_LIMIT}
                data={carouselData}
                isLoading={isLoading}
                scrolling
                propertyViewEventFirePosition="onload"
                title={popularPlaceTitle}
                target={SERP_LARGE_SEARCH_TERM_DESTINATION}
            />
        );
    }
}

const mapDispatchToProps = {
    locationSearch: routerActions.locationSearch
};

export default compose(
    injectIntl,
    connect(null, mapDispatchToProps),
    withLingua({
        namespace: 'discovery/xplorer',
        category: 'messages'
    })
)(DestinationCarousel);
